import { LocalizationInfoProviderInterface } from "@lib/LocalizationInfoProvider/LocalizationInfoProviderInterface";
import { singleton } from "tsyringe";

import TranslationsApiService from "../TranslationsApiService/TranslationsApiService";
import { I18nApiLoader } from "./loaders/I18nApiLoader/I18nApiLoader";

@singleton()
class I18nApiLoaderFactory {
    constructor(
        private readonly localizationInfoProvider: LocalizationInfoProviderInterface,
        private readonly translationsApiService: TranslationsApiService
    ) {}

    getLoader(namespace: string) {
        return new I18nApiLoader(
            namespace,
            this.localizationInfoProvider.getGwI18nLocale(),
            this.translationsApiService
        );
    }
}

export default I18nApiLoaderFactory;
